export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-900 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-black text-white mb-4">
                随时随地，畅享吃瓜
              </h2>
              <p className="text-foreground-300 text-sm md:text-base leading-relaxed mb-6">
                吃瓜在线已全面适配移动端浏览，无论你使用手机还是平板，都能获得流畅的浏览体验。
                无需下载安装，打开浏览器即可访问51吃瓜在线、91吃瓜在线、17吃瓜在线等全部入口。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 font-semibold rounded-lg cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                  <i className="ri-smartphone-line text-lg"></i>
                  手机端访问入口
                </div>
                <a
                  href="#cards"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line"></i>
                  立即浏览内容
                </a>
              </div>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[320px] p-6 lg:p-0 lg:pr-10 flex justify-center">
              <div className="relative w-48 h-80 rounded-2xl border-2 border-foreground-700 bg-foreground-800 overflow-hidden">
                <div className="p-3">
                  <div className="flex items-center gap-1.5 mb-3">
                    <div className="w-5 h-5 rounded-full bg-primary-500 flex items-center justify-center">
                      <i className="ri-chat-3-line text-white text-xs"></i>
                    </div>
                    <span className="text-xs text-white font-medium">吃瓜在线</span>
                  </div>
                  <div className="space-y-2">
                    <div className="h-2.5 w-3/4 rounded-full bg-foreground-600"></div>
                    <div className="h-2.5 w-full rounded-full bg-foreground-600"></div>
                    <div className="h-2.5 w-5/6 rounded-full bg-foreground-600"></div>
                  </div>
                  <div className="mt-3 space-y-2">
                    <div className="h-16 rounded-lg bg-foreground-700"></div>
                    <div className="h-16 rounded-lg bg-foreground-700"></div>
                    <div className="h-16 rounded-lg bg-foreground-700"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}